/* eslint react/prop-types: 0 */

import React from "react";
import { useSelector } from "react-redux";
import { Label, Loader } from "semantic-ui-react";
import { Button, Icon } from "semantic-ui-react";
import Axios from "axios";
import { BASE_URL } from "../../constants";
import { toast } from "react-toastify";
import { PDFPreview } from "../../component/pdfView";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import moment from "moment-timezone";

export default () => {
  const axiosConfig = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
  const inputs = [[{ value: null }], [{ value: null }], [{ value: null }]];
  const categories = [
    { key: 0, value: "Laporan Keuangan" },
    { key: 1, value: "Laporan Kinerja" },
    { key: 2, value: "Laporan Lainnya" },
  ];
  const [onDelete, setOnDelete] = React.useState(false);
  const [selectedDoc, setSelectedDoc] = React.useState({});
  const [modalDelete, setModalDelete] = React.useState(false);
  const [openPDF, setOpenPDF] = React.useState(false);
  const [inputList, setInputList] = React.useState(inputs);
  const { dataReport, isLoading } = useSelector((state) => state.reportReducer);
  const [data, setData] = React.useState();
  const filter = useSelector((state) => state.main);

  React.useEffect(() => {
    setData(dataReport?.content);
    setInputList(inputs);
  }, [dataReport]);

  if (data === undefined) return <div />;

  const upload = (e, type, list) => {
    e.preventDefault();
    if (list.length === 0 || list[0].value === null) {
      toast.error("Silakan pilih file terlebih dulu");
      return;
    }
    const formData = new FormData();
    for (const f of list) formData.append("files", f.value);
    formData.append("type", type + 1);
    formData.append("month", filter.monFilter);
    formData.append("year", filter.yearFilter);
    const url = `${BASE_URL}/document/upload`;
    Axios.post(url, formData, axiosConfig)
      .then((response) => {
        const dt = [...data, ...response.data];
        setData(dt);
        const a = [...inputList];
        a[type] = [{ value: null }];
        setInputList(a);
        toast.success("Berhasil upload dokumen");
      })
      .catch((err) => {
        if (!err.response) toast.error("Internet offline");
        else toast.error(err.response.data.message);
      });
  };

  const deleteInput = (index, key) => {
    let a = [...inputList];
    a[key].splice(index, 1);
    setInputList(a);
  };

  const addInput = (e, key) => {
    if (e) e.preventDefault();
    const value = null;
    let a = [...inputList];
    a[key] = [...a[key], { value }];
    setInputList(a);
  };

  const handleInputChange = (event, key) => {
    const type = key.split("_")[0] * 1;
    const index = key.split("_")[1] * 1;
    const target = event.target;
    const value = target.type === "file" ? event.target.files[0] : target.value;
    const a = [...inputList];
    a[type][index] = { value };
    setInputList(a);
  };

  const previewPDF = (e, d) => {
    e.preventDefault();
    setOpenPDF(true);
    setSelectedDoc(d);
  };

  const deleteFile = () => {
    setOnDelete(true);
    const url = `${BASE_URL}/document/${selectedDoc.id}`;
    Axios.delete(url, axiosConfig)
      .then((response) => {
        toast.success("Berhasil hapus document");
        const a = data.filter((f) => f.id !== selectedDoc.id);
        setData(a);
        setModalDelete(false);
        setOnDelete(false);
      })
      .catch((err) => {
        if (!err.response) toast.error("Internet offline");
        else toast.error(err.response.data.message);
        setModalDelete(false);
        setOnDelete(false);
      });
  };
  const warnDelete = (d) => {
    setSelectedDoc(d);
    setModalDelete(true);
  };

  const getList = (type) => {
    const dt = data.filter((d) => d.type === type + 1);
    const n = new Date().getTime();
    return (
      <table className="table">
        <tbody>
          {dt.map((d, i) => (
            <ViewFile
              key={`${type}_${i}`}
              fileName={d.name || d.id}
              fileLabel={d.createdAt ? moment(d.createdAt).format("DD MMMM YYYY") : ""}
              onClick={(e) => previewPDF(e, d)}
              onDelete={(e) => warnDelete(d)}
            />
          ))}
          {inputList[type].map((d, i) => (
            <InputFile
              key={`x_${i}`}
              onDelete={(e) => deleteInput(i, type)}
              onChange={(e) => handleInputChange(e, `${type}_${i}`)}
            />
          ))}
        </tbody>
      </table>
    );
  };
  if (isLoading) {
    return (
      <div className="w-100 d-flex justify-content-center">
        <Loader active>Loading</Loader>
      </div>
    );
  }

  return (
    <>
      <h3 className="mb-4">
        Dokumen Laporan - {filter.labelMonth} {filter.yearFilter}
      </h3>
      <p>Upload Dokumen Laporan Gabungan dalam bentuk PDF</p>
      {categories.map((c, i) => {
        return (
          <div key={i}>
            <h5>{c.value}</h5>
            <div style={{ marginBottom: "5px" }}>
              <Button
                basic
                color="blue"
                size="mini"
                onClick={(e) => addInput(e, c.key)}
              >
                <Icon name="add" />
                Tambah
              </Button>
              {inputList[c.key]?.length > 0 && (
                <Button
                  basic
                  size="mini"
                  color="blue"
                  onClick={(e) => upload(e, c.key, inputList[c.key])}
                >
                  <Icon name="cloud upload" />
                  Upload
                </Button>
              )}
            </div>
            {getList(c.key)}
            <br />
          </div>
        );
      })}
      <Modal isOpen={openPDF} toggle={() => setOpenPDF(!openPDF)} size="lg">
        <ModalHeader toggle={() => setOpenPDF(!openPDF)}>
          {selectedDoc.name}
        </ModalHeader>
        <ModalBody style={{ maxHeight: "calc(100vh - 210px)" }}>
          <PDFPreview doc={selectedDoc} />
        </ModalBody>
      </Modal>
      <Modal isOpen={modalDelete} toggle={() => setModalDelete(!modalDelete)}>
        <ModalBody className="text-center my-3">
          <Icon color="red" name="trash alternate outline" size="large" />
          <h3>Delete Dokumen</h3>
          <p>
            Apakah Anda yakin akan menghapus Dokumen{" "}
            <span className="font-weight-bold">{selectedDoc.name}</span> ?
            <br />
            Proses ini tidak dapat diurungkan.
          </p>
          <div>
            <Button
              className="mr-3"
              disabled={onDelete}
              onClick={(e) => setModalDelete(false)}
            >
              Cancel
            </Button>
            <Button primary disabled={onDelete} onClick={(e) => deleteFile()}>
              Delete
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

const InputFile = (props) => {
  return (
    <tr>
      <td>
        <div className="form-control">
          <input
            type="file"
            accept="application/pdf"
            onChange={props.onChange}
          />
        </div>
      </td>
      <td>
        <Button
          circular
          color="red"
          icon="trash alternate outline"
          size="mini"
          type="button"
          onClick={props.onDelete}
        />
      </td>
    </tr>
  );
};


const ViewFile = (props) => {
  return (
    <tr>
      <td>
        <a href="#" onClick={props.onClick}>
          {props.fileName}
        </a>
      </td>
      <td>
        <span>
          di-<em>upload</em> : {props.fileLabel}
        </span>
      </td>
      <td>
        <Button
          circular
          color="red"
          icon="trash alternate outline"
          size="mini"
          type="button"
          onClick={props.onDelete}
        />
      </td>
    </tr>
  );
};
